import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ClockDateFilter } from './shared/models';
import { AppPageComponent } from '../shared/ui/app-page/app-page.component';
import { TopLevelComponent, User, HeaderAction } from '../shared/models';
import { Store, StoreHelper, UserService } from '../shared/services';
import { LocationEmployeeLog } from './shared/models';
import { Subscription } from 'rxjs';
import { ClockInOutService } from './shared/services';
import { Component, ViewChild, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { DateTimePickerComponent } from 'ng2-material-components/ng2-material-components';


@Component({
    template: require('./clock-in-out.component.pug'),
})
export class ClockInOutComponent extends TopLevelComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(DateTimePickerComponent) datetimePicker;

    fgSub: Subscription;
    logSub: Subscription;
    fg = new FormGroup({});
    clockInOutLogs: LocationEmployeeLog[] = [];
    date: moment.Moment;
    error: string = '';
    loading = true;
    private _user: User;
    private _headerAction = { id: 'changeDate', icon: 'calendar' };

    constructor(store: Store,
                storeHelper: StoreHelper,
                userService: UserService,
                private clockInOutSvc: ClockInOutService) {
        super(store, storeHelper, userService);
        this.headerTitle = 'Clock In/Out';
        this.headerActions = [{ id: 'none', icon: 'none' }];
        this.userService.user$.subscribe(user => this._user = user);
    }

    ngOnInit() {
       this.date = moment();
       let dateFilter = new ClockDateFilter(this.date);
       this._updateLogs(dateFilter);
       this.headerActions = [ this._headerAction ];
       this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngAfterViewInit() {
       this.fgSub = this.fg.controls['date'].valueChanges
                        .subscribe(value => this.onDateChanged(value));
    }


    _updateLogs(filter: ClockDateFilter) {
         if (this.logSub) { this.logSub.unsubscribe(); }

         this.loading = true;
         this.appPage.activatePreloader();

         this.logSub = this.clockInOutSvc.getLocationEmployeeLogs(filter)
            .subscribe(
                l => this.clockInOutLogs = l,
                err => this.error = err,
                () => this.requestSuccess()
        );
    }

    ngOnDestroy() {
        this.logSub.unsubscribe();
        this.fgSub.unsubscribe();
    }

    requestSuccess() {
        this.loading = false;
        this.appPage.deactivatePreloader();
    }

    locationHasLogs(locationId: number): Boolean {
        let locationLog = this.clockInOutLogs.find( l => l.id === locationId);
        return locationLog !== undefined && locationLog !== null;
    }

    getLocationLogById(locationId: number): LocationEmployeeLog {
        return this.clockInOutLogs.find(l => l.id === locationId) || null;
    }

    onDateChanged(value: string) {
        let filter = new ClockDateFilter(value);
        this._updateLogs(filter);
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._headerAction.id) {
            this.datetimePicker.el.focus();
        }
    }

    get user(): User {
        return this._user;
    }

    get dateFormatted() {
        return this.date.format('MM/DD/YYYY');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/clock-in-out.component.ts